"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f3926 = void 0;
exports.f3926 = {
    "བོད་སྐད་": [
        997,
        998
    ]
};
